import { Component, ElementRef, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

export interface Item {
  icon: string;
  text: string;
  link: string;
  children?: SubItem[];
  count?: number;
  external?: boolean;
}

export interface SubItem {
  text: string;
  link: string;
  children?: Exclude<SubItem, 'children'>[];
  count?: number;
  external?: boolean;
}

export interface Group {
  items: Item[];
}

@Component({
  selector: 'rl-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  imports: [CommonModule, MatIconModule, RouterModule, MatTooltipModule, TranslateModule],
})
export class SidebarComponent implements OnChanges {
  @Input() groups: Group[];
  @Input() open = false;

  constructor(private element: ElementRef) {}

  toggleSubitems(event: MouseEvent) {
    ((event.currentTarget as HTMLElement).parentNode as HTMLElement).classList.toggle('open');
    event.stopPropagation();
  }

  ngOnChanges() {
    this.element.nativeElement.toggleAttribute('open', this.open);
  }
}
